export type AmplitudeOfferPromotionLocation = "investment_page" | "property_page";

export type AmplitudeOfferPromotionCreativeSlot = "modal" | "cta_box" | "promotion_box" | "header_promotion_badge";

export interface IAmplitudeOfferPromotionTrackingParams {
    creativeName: string;
    creativeSlot: AmplitudeOfferPromotionCreativeSlot;
    promotionId?: number;
    promotionName: string;
    promotionContent?: string | null;
    location: AmplitudeOfferPromotionLocation;
    itemListId?: string;
    itemId: number;
    propertyId?: number;
}

export const getAmplitudeOfferPromotionEventProperties = (params: IAmplitudeOfferPromotionTrackingParams) => ({
    creative_name: params.creativeName,
    creative_slot: params.creativeSlot,
    promotion_name: params.promotionName,
    location: params.location,
    item_id: params.itemId,
    ...(params.promotionId != null && {promotion_id: params.promotionId}),
    ...(params.promotionContent && {promotion_content: params.promotionContent}),
    ...(params.itemListId && {item_list_id: params.itemListId}),
    ...(params.propertyId != null && {property_id: params.propertyId})
});
export type AmplitudeOfferPromotionLocation = "investment_page" | "property_page";

export type AmplitudeOfferPromotionCreativeSlot = "modal" | "cta_box" | "promotion_box" | "header_promotion_badge";

export interface IAmplitudeOfferPromotionTrackingParams {
    creativeName: string;
    creativeSlot: AmplitudeOfferPromotionCreativeSlot;
    promotionId?: number;
    promotionName: string;
    promotionContent?: string | null;
    location: AmplitudeOfferPromotionLocation;
    itemListId?: string;
    itemId: number;
    propertyId?: number;
}

export const getAmplitudeOfferPromotionEventProperties = (params: IAmplitudeOfferPromotionTrackingParams) => ({
    creative_name: params.creativeName,
    creative_slot: params.creativeSlot,
    promotion_name: params.promotionName,
    location: params.location,
    item_id: params.itemId,
    ...(params.promotionId != null && {promotion_id: params.promotionId}),
    ...(params.promotionContent && {promotion_content: params.promotionContent}),
    ...(params.itemListId && {item_list_id: params.itemListId}),
    ...(params.propertyId != null && {property_id: params.propertyId})
});
